export const environment = {
  production: true,

  // serverUrl: 'http://localhost:3000/',
  //  serverUrl: 'https://gsfapi.educian.com/'
  //serverUrl:'https://gsfprodapi.educian.com/',
  //  serverUrl:'https://gsfapidev.educian.com/',
   serverUrl: 'https://prodapi.gsfidp.com/',
  forgetPasswordReturnUrl: 'reset-password',
  recaptcha: {
    siteKey: '6LeBiuciAAAAAHViIkJulVOeHFy1ZtGwD5yJKNvf'
  },
};
